import angular from 'angular';

angular.module('cloudX').filter('tenantConfiguration', [
  'checkTenantConfiguration',
  function(checkTenantConfiguration) {
    return function(sec) {
      return checkTenantConfiguration(sec);
    };
  },
]);
